import React from 'react';
import FooterLanding from './components/FooterLanding.js';
import HeaderLandingNuevo from './components/HeaderLandingNuevo';
import Formulario from './components/Formulario.js';


// CAMPAÑA GANAENERGIA.ES
let _telefonoParaLlamar = '900 535 689';
let _cid = '60dad9b93e08325c65696e65';
let _response = 'https://ganaenergia.com/gracias-por-contactarnos';

function App() {

  const tresCosasDeNosotros = [

    {
      title: 'Tarifas de luz y gas baratas y claras',
      desc: 'Somos una compañía eléctrica barata y transparente. Para que ahorres y ganes tranquilidad.',
      img: '/assets/img/centro.svg',
      alt: 'Tarifas de luz y gas baratas y claras'
    },
    {
      title: 'Asesoramiento personalizado',
      desc: 'Nuestros agentes te ayudarán a elegir la opción con la que menos pagarás.',
      img: '/assets/img/personas.svg',
      alt: 'Asesoramiento personalizado'
    },
    {
      title: 'Sencillez al cuadrado',
      desc: 'Hacer las cosas fáciles significa ofrecerte la energía al mejor precio sin sobrecostes ni ataduras.',
      img: '/assets/img/tecnologia.svg',
      alt: 'Sencillez al cuadrado'
    }

  ]

  return (

    <>

      <HeaderLandingNuevo telefono={_telefonoParaLlamar} />

      <div className="flex flex-col justify-between items-center">

        <section className="w-full md:flex md:justify-center bgNeg100 pt-24 pb-10 md:pb-20">
          <div className="w1500 md:flex md:justify-between md:items-center px-4 md:mt-16">
            <div className={`md:max-w-[460px] md:w-1/2 xl:ml-32`}>

              <div className="flex flex-col gap-7">

                <h1>
                  La compañía eléctrica del {" "}
                  <span className='resalted1'>ahorro</span>
                </h1>
                <p className="md:w-9/12">
                  Sin costes adicionales ni permanencia. Simplificamos nuestras tarifas de luz para que tu factura deje de preocuparte.
                </p>
                <div className="flex flex-col gap-3">

                  <div className="flex items-center gap-2">
                    <img src="/assets/img/check.svg" alt="check icon" />
                    <p className='font-medium'>Tranquilidad</p>
                  </div>

                  <div className="flex items-center gap-2">
                    <img src="/assets/img/check.svg" alt="check icon" />
                    <p className='font-medium'>Ahorro</p>
                  </div>

                  <div className="flex items-center gap-2">
                    <img src="/assets/img/check.svg" alt="check icon" />
                    <p className='font-medium'>Sin permanencias</p>
                  </div>

                </div>
                <div className={"butBoxWra"}>
                  <a
                    href={"https://ganaenergia.com/"}
                    className={`butBox butBoxVer med flex items-center py-4 px-6 rounded-full cursor-pointer`}
                  >Visita nuestra web comercial</a>
                </div>

              </div>
            </div>

            <div className={`md:w-1/2 md:flex h-full py-12 items-end`} >
              <iframe
                src="https://www.youtube.com/embed/sx89Rezb584?controls=0&iv_load_policy=3&rel=0&modestbranding=1&showinfo=0&si=ZW4Q3pI1pYDP5h7f"
                title='Anuncio 2024'
                allowFullScreen
                className="max-w-4xl w-full h-52 md:h-full rounded-[24px] md:rounded-[40px]"
              />
            </div>
          </div>
        </section>

        <section className={`flex w-full justify-center py-10 md:py-20`}>
          <div className="w-full w1200 px-7 flex flex-col justify-center items-center">

            <h2 className={`py-4 text-center max-w-2xl`}>
              Tres cosas que debes saber sobre nosotros
            </h2>

            <div className={`md:py-12 grid md:grid-cols-3 gap-6 md:gap-16 mx-auto md:px-8`}>
              {tresCosasDeNosotros?.map((item, key) => {
                return (
                  <div key={key} className="flex flex-col items-center text-center md:text-left">
                    <img
                      src={item.img}
                      alt={item.alt}
                      width={340}
                      height={280}
                      className="lg:h-64 md:h-44 h-24"
                    />
                    <div className="h-auto m-5 md:m-3">
                      <p className={`text-xl md:text-2xl lg:text-3xl font-medium`}>{item.title}</p>
                      <p className="pt-2 md:pt-5 font-light">{item.desc}</p>

                    </div>
                  </div>
                );
              })}
            </div>

            <div className={"butBoxWra mt-4 md:mt-2"}>
              <a
                href={"https://ganaenergia.com/"}
                className={`butBox butBoxVer font-medium text-base flex items-center py-6 px-8 rounded-full cursor-pointer`}
              >Quiero saber más</a>
            </div>

          </div>
        </section>


        <section className="flex w-full justify-center bgNeg100 py-12 md:py-20">
          <div className="w1500 md:flex md:items-center">
            <div className="md:w-1/2 px-4 grid md:justify-end">
              <div className="max-w-lg">
                <h2>
                  Ponemos al
                  cliente en el <span className="resalted1">centro</span>
                </h2>
                <p className="lg:w-4/5 my-4 font-light">
                  Queremos que cambies tu opinión sobre las compañías eléctricas.<br></br>

                  Lo hacemos poniéndote en el centro para que ahorres y disfrutes de la tranquilidad de tener tu hogar en buenas manos.
                </p>

              </div>
            </div>
            <div
              className="md:flex md:items-center md:w-1/2 md:justify-end ml-32 md:ml-0"
              style={{ borderRadius: "40px 0 0 40px" }}
            >
              <img
                src="/assets/img/clientes-gana.png"
                alt={"Clientes Gana Energía"}
                width={620}
                height={497}
              />
            </div>
          </div>
        </section>

        <section className="flex w-full justify-center bgVer900 py-12 md:py-20">
          <div className="w-96 flex flex-col items-center px-10 md:px-4">
            <h2 className='colNeg100'>
              ¿Te llamamos?
            </h2>

            <p className="colNeg100 mt-3 font-extralight text-base md:text-xl">
              O llama gratis al{" "}
              <a
                href={`tel:${_telefonoParaLlamar}`}
                className='font-bold'
              >{_telefonoParaLlamar}</a>
            </p>

            <div className="mt-8 w-full">
              <Formulario response={_response} cid={_cid} />
            </div>

          </div>
        </section>

      </div>

      <FooterLanding />

    </>

  );
}

export default App;
